/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_TicketsInputs */

const en_admin_nav_tickets = /** @type {(inputs: Admin_Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

const zh_admin_nav_tickets = /** @type {(inputs: Admin_Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单管理`)
};

/**
* | output |
* | --- |
* | "Tickets" |
*
* @param {Admin_Nav_TicketsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_tickets = /** @type {((inputs?: Admin_Nav_TicketsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_TicketsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_tickets(inputs)
	return zh_admin_nav_tickets(inputs)
});
export { admin_nav_tickets as "admin.nav.tickets" }